'use client'

import Link from 'next/link'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import { BellDot, Menu, X } from 'lucide-react'
import { Button } from '@/shadcn/components/ui/button'
import { useState } from 'react'
import { useTheme } from '@/themes/admin/context/ThemeContext'

export function SiteHeader() {
  const pathname = usePathname()
  const [mobileOpen, setMobileOpen] = useState(false)
  const [isClockedIn, setIsClockedIn] = useState(false)

  const { getCurrentUser } = useTheme();
  const currentUser = getCurrentUser();




  return (
    <header className="sticky top-0 z-50 w-full border-b  border-gray-300 bg-white">
      <div className="mx-auto max-w-7xl ">
        <div className="flex h-16 items-center justify-between">

          {/* 🔹 Logo Section */}
          <Link href="/" className="flex items-center">
            <Image
              src="/N-blue.png"
              alt="Orgone NX"
              width={50}
              height={50}
              priority
              className="object-contain"
            />
            <span className="text-lg font-bold tracking-wide  text-blue-800">
              OrgoneNX
              <p className='font-semibold text-sm text-gray-500'>Operational Precision</p>
            </span>
          </Link>



          {/* 🔹 Right Section */}
          <div className="flex items-center gap-4">


            {/* Mobile Menu Button */}
            <button
              className="md:hidden"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>


          {/* <div className='flex gap-3 items-center  cursor-pointer'>
            <button
              onClick={() => setIsClockedIn(!isClockedIn)}
              className="flex items-center gap-3 border-2 border-gray-300 rounded-xl p-1 bg-[#F0F3FF] transition-all"
            >
              <div
                className={`rounded-full h-2 w-2 ${isClockedIn ? "bg-green-500" : "bg-red-600"
                  }`}
              />

              <span className="text-xs font-semibold text-gray-500">
                {isClockedIn ? "Logged In" : "Logged Out"}
              </span>

              <span className="text-xs font-semibold bg-blue-800 px-3 py-1 rounded-xl text-white">
                {isClockedIn ? "Clock Out" : "Clock In"}
              </span>
            </button>

            <div className=''>

              <BellDot className="text-gray-500" size={20} />
            </div>

            <div className='bg-blue-800 font-extrabold rounded-xl text-white text-xs p-2 ml-3 cursor-pointer'>
              <label>
                {currentUser?.name
                  ?.split(" ")
                  .map((word: string) => word[0])
                  .join("")}
              </label>
            </div>


          </div> */}

        </div>







      </div>
    </header>
  )
}